import React from "react";
import "./style.css";
import ContactSpin from "../SpinMasterPrivacyPolicy/ContactSpin";

const MonopolyPrivacyPolicy = () => {
  return (
    <div className="monopoly-policy-main" style={{ backgroundColor: "transparent" }}>
      <h1>Privacy Policy For Dice Links for Monopoly GO</h1>
      <p>Last Updated: 29 May, 2026</p>
      <p>
        Welcome to Dice Links for Monopoly GO (the "Application"). This Privacy
        Policy explains how we collect, use, disclose, and safeguard your information
        when you use our Application. We are committed to protecting your privacy and
        ensuring a safe experience.
      </p>

      <h2>1. Information We Collect</h2>
      <p>Our Application collects the following information to function properly and provide you with a great experience:</p>
      <ul>
        <li><strong>Usage Data & Analytics:</strong> We collect anonymous data about how you interact with the app (e.g., features used, session duration, and crash reports) via Firebase Analytics to improve stability and user experience.</li>
        <li><strong>Device Information:</strong> We collect technical information such as your device model, operating system, and unique device identifiers (like the Google Advertising ID).</li>
        <li><strong>Approximate Location:</strong> General location derived from your IP address is used solely for analytics and regional ad relevance. We do NOT request or track precise GPS location.</li>
        <li><strong>Push Notifications (Optional):</strong> If you choose to allow them, we may collect a device token to send you alerts about new rewards or app updates.</li>
      </ul>

      <h2>2. How We Use Your Information</h2>
      <p>We use the collected information exclusively to:</p>
      <ul>
        <li>Provide, operate, and maintain the Application's core features.</li>
        <li>Serve relevant advertisements to support the app's development.</li>
        <li>Analyze usage trends and resolve technical bugs.</li>
      </ul>

      <h2>3. Third-Party Services</h2>
      <p>We use trusted third-party services that may collect information to provide analytics and serve advertisements. These include:</p>
      <ul>
        <li>
          <strong>Google Analytics (Firebase):</strong> Used to collect crash reports and anonymous usage data. Read their <a href="https://policies.google.com/privacy" target="_blank" rel="noreferrer">Privacy Policy</a>.
        </li>
        <li>
          <strong>Google AdMob:</strong> Integrated to display targeted advertisements. AdMob may collect your Advertising ID. Read more at <a href="https://policies.google.com/technologies/ads" target="_blank" rel="noreferrer">Google's Privacy & Terms</a>.
        </li>
      </ul>

      <h2>4. Data Security</h2>
      <p>
        We implement commercially reasonable security measures to protect your data. Since our app primarily provides external links and rewards, we do not require you to create an account or provide sensitive personal data (like names, emails, or passwords).
      </p>

      <h2>5. Your Choices & Opt-Out</h2>
      <p>You have control over how your data is shared with ad networks:</p>
      <ul>
        <li>
          <strong>iOS Users (App Tracking Transparency):</strong> You can opt-out of personalized advertising by going to your device Settings &gt; Privacy &gt; Tracking, and disabling "Allow Apps to Request to Track" for our Application.
        </li>
        <li>
          <strong>Push Notifications:</strong> You can opt-out of receiving push notifications at any time by changing the notification settings on your device.
        </li>
        <li>
          <strong>Data Deletion Request:</strong> If you wish to have any analytics or advertising data associated with your device deleted, please contact us using the information below.
        </li>
      </ul>

      <h2>6. Children's Privacy</h2>
      <p>
        Our Application is not directed at children under the age of 13. We do not knowingly collect personal information from children. If you believe we have inadvertently collected such data, please contact us so we can delete it.
      </p>

      <h2>7. Links to Other Websites</h2>
      <p>
        Our Application may contain links to third-party websites or services (such as official game pages or social media rewards links) that are not owned or controlled by us. We have no control over, and assume no responsibility for, the content, privacy policies, or practices of any third-party websites or services.
      </p>

      <h2>8. Your Data Protection Rights (GDPR & CCPA)</h2>
      <p>
        Depending on your location (such as the EU or California), you may have the right to access, update, or delete the information we have on you. To exercise these rights, please contact us. We do not sell your personal data.
      </p>

      <h2>9. Changes to This Policy</h2>
      <p>
        We may update this Privacy Policy periodically. We encourage you to review this page occasionally. Your continued use of the Application after changes are posted constitutes your acceptance of the new policy.
      </p>

      <h2>10. Contact Us</h2>
      <p>If you have any questions, concerns, or feedback regarding this Privacy Policy, please contact us at:</p>
      <ContactSpin isMonopoly={true} />
    </div>
  );
};

export default MonopolyPrivacyPolicy;
